import script from "./NewsfeedSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsfeedSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./NewsfeedSettingsModal.vue?vue&type=style&index=0&id=7c251dda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c251dda"]])

export default __exports__